import React, {useState} from "react";
// reactstrap components
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  
} from "reactstrap";
import DatePicker from "react-datepicker"

const BookingCards = (props) => {

  const checkInTimeChange = (e) =>{
    console.log(e)
  }

  const checkOutTimeChange = (e) =>{
    console.log(e)
  }
   
    return (
            <Col className="mb-2" xl="6">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">{props.title} </h3>
                    </div>
                    <div className="col">
                      <h3 className="mb-0">{props.property} </h3>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row className="align-items-center">
                    <div className="col text-center">
                      <strong> <label className="text-green">Company:</label></strong> {props.uid.split("@")[1]}
                      <br/>
                      <strong> <label className="text-green">Check In:</label></strong> {props.dtstart}
                      <br/>
                      <strong> <label className="text-green">Check Out:</label></strong> {props.dtend}
                      <br/>
                      
                    </div>
                  </Row>
                  <Row>
                    <div className="col">
                      <strong> <label className="text-green">Check In Time:</label></strong>
                      <DatePicker
                        selected={new Date(props.dtstart)}
                        onChange={checkInTimeChange}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                      />
                    </div>
                    <div className="col">
                      <strong> <label className="text-green">Check Out Time:</label></strong>
                      <DatePicker
                        selected={new Date(props.dtend)}
                        onChange={checkOutTimeChange}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        timeCaption="Time"
                        dateFormat="h:mm aa"
                      />
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Col>
                );
  
            }
            
            export default BookingCards;